import { useState } from "react";
import Message from "../../../../i18n/Message";
import ModalDialog from "../../../shared/ModalDialog";
import "./GenerateExampleDialog.scss";
import label from "../../../../i18n/label";
import { useIntl } from "react-intl";
import { PlusIcon } from "lucide-react";
import Spinner from "../../../../assets/icons/Spinner";
import backend from "../../../../backend/backend";
import Notify from "../../../shared/Notify";

const GenerateExampleDialog = ({ onClose, playground, onFinished }) => {
  const intl = useIntl();
  const [formElem, setFormElem] = useState(null);
  const [prompt, setPrompt] = useState("");
  const [loading, setLoading] = useState(false);

  const onGenerate = () => {
    setLoading(true);

    backend
      .generatePlaygroundExample(playground.uid, { prompt })
      .then((resp) => {
        setLoading(false);
        if (resp) {
          onFinished(resp);
        } else {
          Notify.error(label(intl, "error_unexpected"));
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        Notify.error(label(intl, "error_unexpected"));
      });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    onGenerate();
  };

  return (
    <ModalDialog className="generate_example_dialog" onClose={onClose}>
      <div className="modal_title">
        <Message id="generate_example_dialog_title" />
      </div>
      <form onSubmit={onSubmit} ref={(val) => setFormElem(val)}>
        <div className="dialog_body_row">
          <p>
            <Message id="generate_example_prompt_label" />
          </p>
          <textarea
            id="generate_example_prompt"
            rows="3"
            onChange={(e) => setPrompt(e.target.value)}
            value={prompt}
            placeholder={label(intl, "generate_example_prompt_placeholder")}
            className="form-control"
            readOnly={loading}
          ></textarea>
        </div>
        {loading && (
          <div className="loading_hint">
            <Message id="generate_example_loading_hint" />
          </div>
        )}
        <div className="buttons">
          <button
            className="btn bg-gradient-dark"
            disabled={loading}
            onClick={onGenerate}
          >
            {loading ? <Spinner size="18" /> : <PlusIcon size={16} />}
            <Message id="generate" />
          </button>
          <button className="btn no-btn" onClick={onClose}>
            <Message id="cancel" />
          </button>
        </div>
      </form>
    </ModalDialog>
  );
};

export default GenerateExampleDialog;
